export function adultRole(currentHousehold) {
  const parents =
    currentHousehold?.householdRoles?.filter(
      (member) => member.household_role === "parent_guardian",
    ) || []
  return parents.length ? "other_adult" : "adult"
}

export function newMemberDefaultHouseholdRole(currentHousehold) {
  const children =
    currentHousehold?.householdRoles?.filter(
      (member) => member.household_role === "child_or_dependent",
    ) || []
  const parents =
    currentHousehold?.householdRoles?.filter(
      (member) => member.household_role === "parent_guardian",
    ) || []

  return children.length && !parents.length
    ? "parent_guardian"
    : parents.length
      ? "other_adult"
      : "adult"
}
